import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";
import { buildCompanyPlanRequestQuery } from "src/site/companyPlanRequestQuery";

// landIeul: components/CompanyIndex/ClickToAction/index.tsx。
// 土地の有無 → 都道府県 → 市区町村 の段階選択で次の select を有効化し、揃うと plan-request へ遷移する。
class SiteCompanyClickToActionController extends Controller {
  static targets = ["landSelect", "prefSelect", "townSelect", "planBtn"];
  static values = { cities: Object, medium: String, term: String };

  declare readonly landSelectTarget: HTMLSelectElement;
  declare readonly prefSelectTarget: HTMLSelectElement;
  declare readonly townSelectTarget: HTMLSelectElement;
  declare readonly planBtnTarget: HTMLButtonElement;
  declare readonly citiesValue: Record<string, { id: number; name: string }[]>;
  declare readonly mediumValue: string;
  declare readonly termValue: string;

  changeLand(): void {
    // 土地の有無を選ぶと都道府県 select を有効化。市区町村はリセット。
    this.resetPref();
    this.resetTown();
    this.prefSelectTarget.disabled = this.landSelectTarget.value === "";
  }

  changePref(): void {
    this.resetTown();
    const prefId = this.prefSelectTarget.value;
    const cities = this.citiesValue[prefId] || [];
    this.townSelectTarget.innerHTML = '<option value="0">市区町村を選択</option>';
    cities.forEach((city) => {
      const opt = document.createElement("option");
      opt.value = String(city.id);
      opt.textContent = city.name;
      this.townSelectTarget.appendChild(opt);
    });
    this.townSelectTarget.disabled = prefId === "0";
  }

  changeTown(): void {
    this.planBtnTarget.disabled = this.townSelectTarget.value === "0";
  }

  planRequest(): void {
    const propertyTypeId =
      this.landSelectTarget.value === "true" ? "land_usage_yes" : "land_usage_no";
    const query = `&property-type-id=${propertyTypeId}&pref-id=${this.prefSelectTarget.value}`;
    const trackingQuery = buildCompanyPlanRequestQuery(this.mediumValue, this.termValue);
    window.open(`/plan-request/?${trackingQuery}${query}`, "_self", "noreferrer");
  }

  private resetPref(): void {
    this.prefSelectTarget.value = "0";
  }

  private resetTown(): void {
    this.townSelectTarget.innerHTML = '<option value="0">市区町村を選択</option>';
    this.townSelectTarget.value = "0";
    this.townSelectTarget.disabled = true;
    this.planBtnTarget.disabled = true;
  }
}

application.register("site--company--click-to-action", SiteCompanyClickToActionController);
